import Button from "@mui/material/Button";

export function PlusButton({ onClick, id, disabled, sx }) {
    return (
        <Button
            variant="outlined"
            onClick={onClick}
            disabled={disabled}
            tabIndex={-1} 
            id={id}
            sx={{
                padding: 1,
                minWidth: 40,
                height: 40,
                fontSize: 30,
                ...sx
            }}
        >
            +
        </Button>
    );
}

export function MinusButton({ onClick, id, disabled, sx }) {
    return (
        <Button
            variant="outlined"
            color='error'
            onClick={onClick}
            disabled={disabled}
            tabIndex={-1}
            id={id}
            sx={{
                padding: 1,
                minWidth: 40,
                height: 40,
                fontSize: 30, 
                ...sx
            }}
        >
            -
        </Button>
    );
}